import React from 'react'
import {ServerConfig} from 'config'

import NonPaginatedList from '../../components/EntryListAndEdit/NonPaginatedList'


const Cashdrawers = () => {
  const non_editable_fields = [
    ["id", "id", ""],
    //["owner", "Owner", ""]
  ];

  const editable_fields = [
    ["name", "Name"],
    ["belt_id", "Device ID"],
    ["min_threshold_microdollars", "Low cash threshold", "currency"],
    ["count_diff_notification_trigger_microdollars", "Difference notification threshold", "currency"]
  ];

  return (
    <>
      <NonPaginatedList
        list_get_url={`${ServerConfig.SERVER_URL}/tenant/tenant_cashdrawers`}
        detail_get_url={`${ServerConfig.SERVER_URL}/tenant/tenant_cashdrawers/`}
        detail_put_url={`${ServerConfig.SERVER_URL}/tenant/tenant_cashdrawers/`}

        column_names={["id", "name"]}
        header_names={["id", "name"]}

        optional_column_names={["belt_id", "min_threshold_microdollars", "count_diff_notification_trigger_microdollars"]}
        optional_header_names={["Device ID", "Low cash threshold", "Difference notification threshold"]}

        filter_inputs={[]}

        editable_fields={editable_fields}
        non_editable_fields={non_editable_fields}
        //show_machine_stats={true}
      />
    </>
  )
}

export default Cashdrawers
